import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function NotSection() {
  return <section className="w-full bg-white" aria-label="Lo que esto no es" data-id="element-129">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] text-center leading-tight mb-12" data-id="element-131">
          Lo que esto NO es{' '}
          <span className="block text-lg font-normal text-gray-500 mt-2" data-id="element-132">
            (para ser claros)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-133">
          {/* NOT */}
          <div className="bg-red-50 rounded-2xl p-6 md:p-8" data-id="element-134">
            <h3 className="text-lg font-bold text-[#EF4444] mb-5 uppercase tracking-wide" data-id="element-135">
              No es…
            </h3>
            <div className="space-y-4" data-id="element-136">
              <div className="flex items-start gap-3" data-id="element-137">
                <XIcon className="w-5 h-5 text-[#EF4444] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-138" />
                <p className="text-gray-700 text-lg" data-id="element-139">Una receta médica</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-140">
                <XIcon className="w-5 h-5 text-[#EF4444] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-141" />
                <p className="text-gray-700 text-lg" data-id="element-142">
                  Un reemplazo del dentista
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-143">
                <XIcon className="w-5 h-5 text-[#EF4444] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-144" />
                <p className="text-gray-700 text-lg" data-id="element-145">"Mil tips" desordenados</p>
              </div>
            </div>
          </div>

          {/* IS */}
          <div className="bg-green-50 rounded-2xl p-6 md:p-8" data-id="element-146">
            <h3 className="text-lg font-bold text-[#10B981] mb-5 uppercase tracking-wide" data-id="element-147">
              Sí es…
            </h3>
            <div className="space-y-4" data-id="element-148">
              <div className="flex items-start gap-3" data-id="element-149">
                <CheckIcon className="w-5 h-5 text-[#10B981] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-150" />
                <p className="text-gray-700 text-lg" data-id="element-151">
                  Un protocolo práctico para las próximas 48 horas
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-152">
                <CheckIcon className="w-5 h-5 text-[#10B981] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-153" />
                <p className="text-gray-700 text-lg" data-id="element-154">
                  Un sistema para pasar de pánico a control
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-155">
                <CheckIcon className="w-5 h-5 text-[#10B981] mt-1 flex-shrink-0" aria-hidden="true" data-id="element-156" />
                <p className="text-gray-700 text-lg" data-id="element-157">
                  Tu puente hasta que te atienda un profesional
                </p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 text-base mt-10 italic" data-id="element-158">
          "Esto no reemplaza al dentista. Te lleva a él con control."
        </p>
      </div>
    </section>;
}